import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const siteBaseUrl = `${apiUrl}/site`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const sitesApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${siteBaseUrl}?${query}`);
  },
  save: site => {
    return Axios.post(siteBaseUrl, site, config);
  },
  delete: id => {
    return Axios.delete(`${siteBaseUrl}/${id}`, config);
  },
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return Axios.post(`${siteBaseUrl}/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
